import * as React from 'react';
import * as ReactDOM from 'react-dom';

interface Props {
  children: React.ReactNode;
  container?: Element;
}

/** Render within a portal using a declarative component API. */
export const Portal = ({ children, container }: Props) => {
  const [mounted, setMounted] = React.useState<boolean>(false);
  React.useEffect(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, []);

  return mounted
    ? ReactDOM.createPortal(children, container ?? document.body)
    : null;
};
